module.exports = __webpack_public_path__ + "img/triangle-exclamation-solid-full.e03ec890.svg";